// Angular
import { Injectable, OnDestroy, OnInit } from '@angular/core';

// Libraries
import { Action, Selector, State, StateContext } from '@ngxs/store';

// Models
import { AppCleanup } from '../../../shared/models';

// Store
import { AuthActions } from './auth.action';

export interface AuthStateModel {
	isLoggedIn: boolean;
	authToken: string;
}

const defaultState: AuthStateModel = {
	isLoggedIn: false,
	authToken: undefined,
};

@State<any>({
	name: 'auth',
	defaults: defaultState,
})
@Injectable()
export class AuthState extends AppCleanup implements OnInit, OnDestroy {
	constructor() {
		super();
	}

	ngOnInit() {}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	@Action(AuthActions.SetToken)
	setToken(ctx: StateContext<AuthStateModel>, action: AuthActions.SetToken) {
		ctx.setState({
			isLoggedIn: true,
			authToken: action.token,
		});
	}

	@Action(AuthActions.DeleteToken)
	deleteToken(ctx: StateContext<AuthStateModel>) {
		ctx.setState({
			isLoggedIn: false,
			authToken: undefined,
		});
	}

	@Selector()
	static isLoggedIn(state: AuthStateModel): boolean {
		return state.isLoggedIn;
	}

	@Selector()
	static currentAuthToken(state: AuthStateModel): string {
		return state.authToken;
	}
}
